import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { colors, fonts } from '../mui-theme';
import { alpha, styled } from '@mui/material/styles';

export const FacetedFilterToggleButton = (props) => {
    const dispatch = useDispatch();
    const { group } = props;

    // Skip if not two alternatives
    if (!(group?.options?.length === 2)) return;

    const [isChecked, setIsChecked] = useState(() => {
        let isSelected;
        const somethingSelected = group.selectedOptions.length > 0;
        if (somethingSelected) {
            const selectedId = group.selectedOptions[0];
            const selectedIndex = group.options.findIndex((x) => x.id === selectedId);
            isSelected = selectedIndex === 1;
        }
        return somethingSelected ? isSelected : true;
    });

    const firstOption = group.options[0];
    const secondOption = group.options[1];
    const quantity = secondOption.quantity;

    // Texts, ( currently hardcoded for Show-only-buyable toggle, make generic if we want to use toggle for another case )
    const label = `${translate('code.search.showonlybuyable.togglelabel')} (${quantity})`;
    const toolTip = translate('code.search.showonlybuyable.tooltip');

    const onChangeFunction = useCallback(
        (event) => {
            const option = isChecked ? firstOption : secondOption;
            dispatch(searchFacetChange(group, option, event));
            setIsChecked(event.target.checked);
        },
        [dispatch, group, firstOption, secondOption]
    );

    const GreenSwitch = styled(Switch)(({ theme }) => ({
        '& .MuiSwitch-switchBase.Mui-checked': {
            color: colors.colorprimary100,
            '&:hover': {
                backgroundColor: alpha(colors.colorprimary100, theme.palette.action.hoverOpacity),
            },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: colors.colorprimary100,
        },
    }));

    const FormLabel = styled(FormControlLabel)(() => ({
        marginRight: 0,

        '& .MuiTypography-root ': {
            fontSize: fonts.fontsizesmall,
            fontFamily: fonts.fontprimary,
        },
    }));

    return (
        <FormLabel
            title={toolTip}
            value="start"
            control={
                <GreenSwitch
                    onChange={(event) => onChangeFunction(event)}
                    checked={isChecked}
                />
            }
            label={label}
            labelPlacement="end"
        />
    );
};
